var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientId)?_c('Button',{attrs:{"loading":_vm.loading,"color":"#de5246","dark":""},on:{"click":_vm.handleGoogleSignIn}},[_c('v-icon',{staticClass:"pa-1",attrs:{"text":""}},[_vm._v(" mdi-google ")]),_vm._v(" GOOGLE ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }